<template>
    <auth-layout>
        <div class="auth-error">
            <sep name="XL"></sep>
            <typo name="title-18-bold">
                {{ error }}
            </typo>
        </div>
    </auth-layout>
</template>

<script>
import Vue from "vue";
import AuthLayout from "./AuthLayout.vue";

export default Vue.extend({
    components: {
        AuthLayout,
    },
    data() {
        return {
            error: "",
        };
    },
    async mounted() {
        this.error = this.dico.errors[this.$route.query.code || "auth_general"];
    },
    computed: {
        dico() {
            return this.$publicDico.login;
        },
    },
});
</script>

<style lang="sass" scoped></style>
